import dynamic from 'next/dynamic';
const TitledIconListGroup = dynamic(() => import('./TitledIconListGroup'));

export { type TitledIconListProps } from './TitledIconList';
export { TitledIconListGroup };
